import React, { useContext, useEffect, useState } from 'react';
import { StateContext } from 'context';
import './prestamos.css';
import { Themes } from 'styles';
import { PrestamosPersonales1Img, PrestamosPersonales2Img } from 'assets/img';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FormularioPpCt } from 'app/formulario-pp-ct';
import { FormularioUnipersonalEmpresa } from 'app/formulario-unipersonal-empresa';

const Prestamos = (props) => {
    const state = useContext(StateContext);
    const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    const [verFormulario, setVerFormulario] = useState(false);
    const [verFormularioUnipersonal, setVerFormularioUnipersonal] = useState(false);
    const [verFormularioEmpresa, setVerFormularioEmpresa] = useState(false);
    useEffect(() => {
    }, []);

    return (
        <>
            <div id="prestamos-personales" className="w3-block">
                <div className="w3-content">
                    <div className="w3-row">
                        <div className="w3-col l4 m12 col-imagenes">
                            <div className="w3-row">
                                <div className="w3-col l12 m6 s6">
                                    <div className="w3-block w3-center w3-padding bs-bbox">
                                        <div className="img-container background-cover w3-card"
                                            style={{ backgroundImage: `url(${PrestamosPersonales1Img})` }}>
                                        </div>
                                    </div>
                                </div>
                                <div className="w3-col l12 m6 s6">
                                    <div className="w3-block w3-center w3-padding bs-bbox">
                                        <div className="img-container background-cover w3-card"
                                            style={{ backgroundImage: `url(${PrestamosPersonales2Img})` }}>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w3-rest w3-padding">
                            <h1 style={{ color: Themes[indexTema].D1 }}>Préstamos (Asalariado, Unipersonal y Empresa)</h1>
                            <p>En SERFIN encontrás el préstamo personal que estabas buscando. Con procesos rápidos y ágiles para que dispongas del dinero en el tiempo que lo necesitas. Para gastos personales, para unas merecidas vacaciones, o comprar lo que tanto deseabas. A sola firma, y con mínimos requisitos, son algunas de las ventajas de tu préstamo en SERFIN. Podes solicitar desde 1.000.000 hasta 20.000.000 de guaraníes, y devolver hasta en 24 meses.</p>

                            <p>También te acompañamos en el crecimiento y fortalecimiento de tu emprendimiento comercial, industrial, de servicio o ganadero. Apoyamos a las Microempresas, asi como a las Pequeñas y Medianas Empresas, ofreciendo préstamos a la medida de sus necesidades, con montos y plazos ajustables de acuerdo al flujo financiero del negocio. Plazo de 3 hasta 18 meses.</p>

                            {(!verFormulario && !verFormularioUnipersonal && !verFormularioEmpresa) ? <button className="boton-formulario-online w3-margin-right w3-btn w3-xlarge w3-round-xxlarge w3-theme" onClick={() => setVerFormulario(true)}>Solicitar (Asalariado)</button> : null}
                            {(!verFormulario && !verFormularioUnipersonal && !verFormularioEmpresa) ? <button className="boton-formulario-online w3-margin-right w3-btn w3-xlarge w3-round-xxlarge w3-theme" onClick={() => setVerFormularioUnipersonal(true)}>Solicitar (Unipersonal)</button> : null}
                            {(!verFormulario && !verFormularioUnipersonal && !verFormularioEmpresa) ? <button className="boton-formulario-online w3-btn w3-xlarge w3-round-xxlarge w3-theme" onClick={() => setVerFormularioEmpresa(true)}>Solicitar (Empresa)</button> : null}
                            <br/>
                            <br/>
                            <br/>
                        </div>
                    </div>

                    {verFormulario ? <div>
                        <div className="w3-block w3-card w3-padding bs-bbox w3-animate-bottom">
                            <div className="w3-block" style={{ height: 50 }}>
                                <button className="close-btn w3-btn w3-light-gray" onClick={() => setVerFormulario(false)}>
                                    <FontAwesomeIcon icon={faTimes} />
                                </button>
                                <h1 style={{ color: Themes[indexTema].D1 }}>Solicitud Préstamo (Asalariado)</h1>
                            </div>
                            
                            <FormularioPpCt tipoSolicitud="1" />
                        </div>
                    </div> : null}
                    {verFormularioUnipersonal ? <div>
                        <div className="w3-block w3-card w3-padding bs-bbox w3-animate-bottom">
                            <div className="w3-block" style={{ height: 50 }}>
                                <button className="close-btn w3-btn w3-light-gray" onClick={() => setVerFormularioUnipersonal(false)}>
                                    <FontAwesomeIcon icon={faTimes} />
                                </button>
                                <h1 style={{ color: Themes[indexTema].D1 }}>Solicitud Préstamo (Unipersonal)</h1>
                            </div>
                            <FormularioUnipersonalEmpresa tipoSolicitud={2}/>
                        </div>
                    </div> : null}
                    {verFormularioEmpresa ? <div>
                        <div className="w3-block w3-card w3-padding bs-bbox w3-animate-bottom">
                            <div className="w3-block" style={{ height: 50 }}>
                                <button className="close-btn w3-btn w3-light-gray" onClick={() => setVerFormularioEmpresa(false)}>
                                    <FontAwesomeIcon icon={faTimes} />
                                </button>
                                <h1 style={{ color: Themes[indexTema].D1 }}>Solicitud Préstamo (Empresa)</h1>
                            </div>
                            <FormularioUnipersonalEmpresa tipoSolicitud={3}/>
                        </div>
                    </div> : null}
                </div>
            </div>
        </>
    );
}
export default Prestamos;